<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/member' }">结算管理</el-breadcrumb-item>
            <el-breadcrumb-item>服务结算</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="form-box">
            <div class="step-box">
                <el-steps :active="activeStep" :align-center="true">
                    <el-step title="提交数据" description=""></el-step>
                    <el-step title="审核数据" description=""></el-step>
                    <el-step title="开始打款" description=""></el-step>
                </el-steps>
            </div>
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
export default {
    name: 'payManage',
    data () {
        return {
            activeStep: 1
        }
    },
    mounted () {
        this.indexWatch()
    },
    watch: {
        '$route': 'indexWatch'
    },
    methods: {
        indexWatch () {
            if (this.$route.path.substr(-1, 1) * 1 === 2) {
                this.activeStep = 2
            } else if (this.$route.path.substr(-1, 1) * 1 === 3) {
                this.activeStep = 3
            } else {
                this.activeStep = 1
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "../../assets/style/sub.scss";
    .data-overview {
        height: 78px;
    }
</style>
